if (!customElements.get('collection-infinite-scroll')) {
  class CollectionInfiniteScroll extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.nextUrl || !('IntersectionObserver' in window)) return;

      this.message = this.querySelector('[data-infinite-scroll-message]');
      this.fallbackLink = this.querySelector('.infinite-scroll__fallback');
      this.classList.add('infinite-scroll--active');
      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.loadNextPage();
        },
        { rootMargin: '0px 0px 600px 0px' }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.abortController?.abort();
    }

    async loadNextPage() {
      if (this.loading || !this.dataset.nextUrl) return;

      this.loading = true;
      this.dataset.loading = 'true';
      this.abortController = new AbortController();

      try {
        const response = await fetch(this.dataset.nextUrl, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal: this.abortController.signal,
        });

        if (!response.ok) throw new Error(`Unable to load products (${response.status})`);

        const parsedDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextGrid = parsedDocument.getElementById('product-grid');
        const currentGrid = this.closest('#ProductGridContainer')?.querySelector('#product-grid');

        if (!nextGrid || !currentGrid) throw new Error('The next product grid was not found');

        Array.from(nextGrid.children).forEach((productCard) => {
          productCard.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
          productCard.removeAttribute('data-cascade');
          productCard.style.removeProperty('--animation-order');
          currentGrid.appendChild(productCard);
        });

        const nextLoader = parsedDocument.querySelector('collection-infinite-scroll[data-next-url]');
        const nextUrl = nextLoader?.dataset.nextUrl;

        if (nextUrl) {
          this.dataset.nextUrl = nextUrl;
          if (this.fallbackLink) this.fallbackLink.href = nextUrl;
        } else {
          this.finish();
        }
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.showFallback();
      } finally {
        this.loading = false;
        this.dataset.loading = 'false';
      }
    }

    finish() {
      this.observer?.disconnect();
      this.removeAttribute('data-next-url');
      this.setAttribute('hidden', '');
    }

    showFallback() {
      this.observer?.disconnect();
      this.classList.add('infinite-scroll--error');
      if (this.message) this.message.textContent = 'More products could not be loaded automatically.';
    }
  }

  customElements.define('collection-infinite-scroll', CollectionInfiniteScroll);
}
